import { render, staticRenderFns } from "./createdCuentasCruzadas.vue?vue&type=template&id=3c70275a&scoped=true"
import script from "./createdCuentasCruzadas.vue?vue&type=script&lang=js"
export * from "./createdCuentasCruzadas.vue?vue&type=script&lang=js"
import style0 from "./createdCuentasCruzadas.vue?vue&type=style&index=0&id=3c70275a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70275a",
  null
  
)

export default component.exports